module.exports = __webpack_public_path__ + "img/18.8d2e94fc.jpg";